import React from "react";
import PropTypes from "prop-types";
import Spinner from "assets/img/spinner.svg";
import Translate from "helpers/Translate";

const Button = ({
  handleSubmit,
  className,
  isLoading,
  buttonText,
  btnId,
  buttonIconClass = null,
  disabled = false
}) => {
  const loadingText = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <img src={Spinner} alt="Loading" className="disabled mr-10" />{" "}
        <span>{Translate({ id: "processing" })} </span>
      </div>
    );
  };

  return (
    <button
      onClick={handleSubmit}
      className={className}
      disabled={isLoading || disabled}
      id={btnId}
      style={{ display: "flex", justifyContent: "center" }}
    >
      {isLoading ? (
        loadingText()
      ) : (
        <span>
          {buttonIconClass && <i className={`${buttonIconClass} mr-10`}></i>}
          {buttonText}
        </span>
      )}
    </button>
  );
};

Button.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  btnId: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  buttonIconClass: PropTypes.string,
  disabled: PropTypes.bool
};

Button.defaultProps = {
  buttonText: "Submit",
  isLoading: false
};

export default Button;
